module.exports = __webpack_public_path__ + "static/media/inspector-icon.19ef51d8.svg";